import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import ApexCharts from "apexcharts"
import { getChartData } from "../firebase/users";
import Chart from 'react-apexcharts';


let seriesObject = {
    daily: { name: 'Visits', data: [1] },
    weekly: { name: 'Visits', data: [1] },
    monthly: { name: 'Visits', data: [1] }
}

const ApexChart = () => {
    const [activeTab, setActiveTab] = useState('daily')
    const [series, setSeries] = useState([{ name: 'Visits', data: [1, 2, 3] }])
    const [loading, setLoading] = useState(true)
    const tickAmounts = { 'daily': 7, 'weekly': 4, 'monthly': 12 }

    const [options, setOptions] = useState(
        {
            dataLabels: {
                enabled: false
            },
            markers: {
                size: 0,
                style: 'hollow',
            },
            yaxis: {
                show: true,
                labels: {
                    style: {
                        colors: "#959595"
                    }
                }
            },
            xaxis: {
                categories: [],
                tickAmount: 7,
                labels: {
                    style: {
                        colors: "#959595"
                    }
                },
                axisBorder: {
                    show: true
                }
            },
            toolbar: {
                show: false
            },
            fill: {
                gradientToColors: '#1AB6F9'
            },
            zoom: {
                enabled: false
            }
        }
    );

    useEffect(() => {
        if (!loading) {
            setSeries([seriesObject[activeTab]])
        }

        const newCategories = getLabels(activeTab)
        setOptions({ ...options, xaxis: { ...options.xaxis, categories: newCategories, tickAmount: tickAmounts[activeTab] } })
    }, [activeTab, loading])

    useEffect(() => {
        getChartData('daily').then(data => {
            seriesObject = { ...seriesObject, daily: { name: 'Visits', data: data } }
        })
        getChartData('weekly').then(data => {
            seriesObject = { ...seriesObject, weekly: { name: 'Visits', data: data } }
        })
        getChartData('monthly').then(data => {
            seriesObject = { ...seriesObject, monthly: { name: 'Visits', data: data } }
            setLoading(false)
        })
    }, [])


    function getLabels(type) {
        const labels = [];

        const today = new Date();

        if (type === 'daily') {
            // Generate labels for the last 7 days
            for (let i = 0; i < 7; i++) {
                const date = new Date(today);
                date.setDate(today.getDate() - i); // Subtract days
                labels.push(`${date.getMonth() + 1}/${date.getDate()}`); // Format as MM/DD
            }
        } else if (type === 'weekly') {
            // Generate labels for the last 4 weeks
            for (let i = 0; i < 4; i++) {
                const weekStart = new Date(today);
                weekStart.setDate(today.getDate() - (i * 7)); // Subtract weeks
                labels.push(`Week of ${weekStart.getMonth() + 1}/${weekStart.getDate()}`); // Format as "Week of MM/DD"
            }
        } else if (type === 'monthly') {
            // Generate labels for the last 12 months
            for (let i = 0; i < 12; i++) {
                const monthDate = new Date(today);
                monthDate.setMonth(today.getMonth() - i); // Subtract months
                labels.push(`${monthDate.getMonth() + 1}/${monthDate.getFullYear()}`); // Format as MM/YYYY
            }
        }

        return labels.reverse(); // Reverse the array to show from oldest to newest
    }

    return (
        !loading ?
            <div>
                <div id="chart">
                    <div className="toolbar">
                        <div className="flex items-center mb-4">
                            <div className="text-white mr-4">
                                Analytics
                            </div>

                            <button
                                className={`px-3 py-2 mr-2 rounded-[10px] text-sm ${activeTab === 'daily' ? 'bg-[#F0F1FF]' : 'bg-[#5C5C5C] text-[#B9B9B9]'}`}
                                onClick={() => setActiveTab('daily')}
                            >
                                Daily
                            </button>

                            <button
                                className={`px-3 py-2 mr-2 rounded-[10px] text-sm ${activeTab === 'weekly' ? 'bg-[#F0F1FF]' : 'bg-[#5C5C5C] text-[#B9B9B9]'}`}
                                onClick={() => setActiveTab('weekly')}
                            >
                                Weekly
                            </button>

                            <button
                                className={`px-3 py-2 rounded-[10px] text-sm ${activeTab === 'monthly' ? 'bg-[#F0F1FF]' : 'bg-[#5C5C5C] text-[#B9B9B9]'}`}
                                onClick={() => setActiveTab('monthly')}
                            >
                                Monthly
                            </button>
                        </div>
                    </div>

                    <div id="chart-timeline">
                        <ReactApexChart options={options} series={series} type="area" height={350} />
                    </div>
                </div>
                <div id="html-dist"></div>
            </div> :
            <div className="text-white text-center text-[30px] flex items-center justify-center h-full">
                Loading ...
            </div>
    );
}

export default ApexChart